"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSubmission = exports.newWindowSubmission = exports.buildFormModelSubmissionBody = exports.getFormModelData = exports.getSubmissionRequestData = exports.buildSubmissionBody = void 0;
const render_to_xml_1 = __importDefault(require("../utils/render-to-xml"));
const traverse_model_values_1 = __importDefault(require("../utils/traverse-model-values"));
const interpolate_string_1 = __importDefault(require("../utils/interpolate-string"));
const reporter_1 = __importDefault(require("../reporter"));
const buildSubmissionBody = (models, { modelRef, method = 'post', separator = '&' }) => {
    if (!modelRef)
        return '';
    const { modelIds } = modelRef;
    const { index, id } = modelIds[0];
    const model = models[index];
    if (method.toLowerCase() === 'post') {
        return (0, render_to_xml_1.default)({ model, modelId: id });
    }
    const { values } = (0, traverse_model_values_1.default)({ model, modelId: id });
    return Object.entries(values)
        .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
        .join(separator);
};
exports.buildSubmissionBody = buildSubmissionBody;
const getSubmissionRequestData = (models, modelRef) => {
    const { modelIds } = modelRef;
    const { index, id } = modelIds[0];
    const model = models[index];
    return (0, traverse_model_values_1.default)({ model, modelId: id }).values;
};
exports.getSubmissionRequestData = getSubmissionRequestData;
const getFormModelData = (formModel, formId, submissionData) => {
    let data = {};
    const w = typeof window === 'object' ? window : globalThis;
    if (!submissionData || !w.FormsV2ReferenceTables)
        return data;
    // TODO: not my favorite
    // eslint-disable-next-line no-undef
    const { keyToNode } = w.FormsV2ReferenceTables[formId];
    for (const { name, value, term } of submissionData) {
        if (term) {
            const node = keyToNode[term];
            if (!node) {
                reporter_1.default.warn(`Could not find node for term ${term} in form ${formId} submission`);
                data[name] = '';
                continue;
            }
            data[name] =
                node.type === 'iterable-term'
                    ? formModel[formId].iterables[node.iterableName].instances[node.iterableIndex].terms[node.termName].value
                    : formModel[formId].terms[node.termName].value;
        }
        else {
            data[name] = value;
        }
    }
    return data;
};
exports.getFormModelData = getFormModelData;
const buildFormModelSubmissionBody = (submissionType, formModel, formId, submissionData, separator = '&') => {
    if (!submissionData)
        return '';
    const data = (0, exports.getFormModelData)(formModel, formId, submissionData);
    if (submissionType === 'profile-request') {
        return `<ProfileRequest>
  <Subject typeId="property">
    ${Object.entries(data)
            .map(([key, value]) => `<DataItem name="${key}" value="${value}" />`)
            .join('\n    ')}
  </Subject>
</ProfileRequest>`;
    }
    if (submissionType === 'generic-request') {
        return Object.entries(data)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join(separator);
    }
};
exports.buildFormModelSubmissionBody = buildFormModelSubmissionBody;
const newWindowSubmission = ({ action, body, target, config = {} }) => () => {
    try {
        const url = (0, interpolate_string_1.default)(action, config);
        // eslint-disable-next-line no-undef
        window.open(body ? `${url}?${body}` : url, target /* , 'noopener' */);
        return Promise.resolve();
    }
    catch (e) {
        return Promise.reject(e);
    }
};
exports.newWindowSubmission = newWindowSubmission;
const fetchSubmission = ({ action, method, mediatype, body, config = {} }) => async ({ headers: optHeaders = {}, body: overwriteBody } = {}) => {
    try {
        const url = (0, interpolate_string_1.default)(action, config);
        const headers = {
            'Content-Type': mediatype,
            ...optHeaders,
        };
        // eslint-disable-next-line no-undef
        const response = await fetch(url, {
            method: method.toUpperCase(),
            credentials: 'include',
            headers,
            body: typeof overwriteBody === 'string' ? overwriteBody : body,
        });
        return response.text();
    }
    catch (e) {
        reporter_1.default.error(e);
        return e;
    }
};
exports.fetchSubmission = fetchSubmission;
//# sourceMappingURL=submission.js.map